/**
 * Local constants for the Stripe Checkout Sessions flow.
 *
 * The request/response shapes now come from the regenerated app-api SDK
 * (`@calm-web/api-sdk/lib/app-api`) — see `useCreateCheckoutSession` and
 * `pollCheckoutSessionStatus`. Only genuinely client-local values live here.
 */

/**
 * Bare route (must start with "/") for the Checkout Session return page. Kept as a
 * clean route value; the value actually sent as `returnUrl` is `CHECKOUT_RETURN_URL`
 * (which carries the Stripe session-id template).
 */
export const CHECKOUT_RETURN_PATH = '/checkout/return';

/**
 * The Checkout Session `return_url` we send as `returnUrl` at session creation
 * (api prepends `WWW_ROOT_URL` and forwards the rest verbatim). Stripe redirects
 * genuinely-redirect-required methods (Klarna, Cash App, bank redirects) back here
 * and SUBSTITUTES `{CHECKOUT_SESSION_ID}` with the real session id before redirecting
 * — template-substitution, the same token as hosted `success_url`, NOT an auto-append
 * (confirmed against Stripe Custom Checkout `ui_mode:'elements'` docs). `/checkout/return`
 * then reads `?session_id=cs_…` to verify + fulfill.
 *
 * Without the template, redirect methods landed on `/checkout/return` with no
 * `session_id` → the dead `missing-session` state even though the buyer paid (the live
 * Klarna bug). Card/wallet confirm inline (`redirect:'if_required'`) so they never hit
 * this URL, but the template is harmless for them.
 *
 * The `{CHECKOUT_SESSION_ID}` literal MUST go out UNESCAPED — it is sent as-is in the
 * JSON create-body (no `encodeURIComponent` on the braces); the api's same-origin
 * validation passes it through unmodified. Owned entirely web-side.
 */
export const CHECKOUT_RETURN_URL = `${CHECKOUT_RETURN_PATH}?session_id={CHECKOUT_SESSION_ID}`;
